module.exports = __webpack_public_path__ + "img/home.28a5e48d.jpg";